import { gtmEventPageView } from '../utils/tracking/gaEvents'
import { getLocaleByTld } from '@ocp-zmarta/content-lib'

export const getMetaData = ({ page, site } = {}) => {
  if (!page) return

  const { cookies, gaPageView, seo, structuredData } = page
  const { title, description, canonical, no_index: noIndex, no_follow: noFollow, hreflangs } = seo ?? {}
  const scripts = []
  const noScripts = []
  const disableSanitizers = {}

  const country = site?.split('.').pop()
  const lang = getLocaleByTld(country)
  const robots = [
    noIndex ? 'noindex' : null,
    noFollow ? 'nofollow' : null
  ]
    .filter((r) => r)
    .join(', ')
  const dnsPrefetch = [
    'https://www.google-analytics.com',
    'https://www.googletagmanager.com'
  ]

  if (gaPageView) {
    const zga = gtmEventPageView({ site, gaPageView, cookies })

    // *** ga/gtm pageViewEvent ** //
    Object.assign(scripts, zga?.vueMeta?.scripts || [])
    Object.assign(noScripts, zga?.vueMeta?.noscripts || [])
    Object.assign(disableSanitizers, zga?.vueMeta?.disableSanitizers || {})
  }

  if (structuredData) {
    scripts.push({
      type: 'application/ld+json',
      json: structuredData,
      once: true
    })
  }

  const objHreflangs = []

  if (hreflangs) {
    for (const hrefLang of hreflangs) {
      objHreflangs.push({
        rel: 'alternate',
        ...hrefLang
      })
    }
  }

  return {
    htmlAttrs: { lang },
    title,
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1', once: true },
      { property: 'og:type', content: 'website', once: true },
      ...(robots ? [{ name: 'robots', content: robots, once: true }] : []),
      ...(description ? [{ name: 'description', content: description, once: true }] : []),
      ...(title ? [{ property: 'og:title', content: title, once: true }] : []),
      ...(description
        ? [{ property: 'og:description', content: description, once: true }]
        : []),
      ...[{ property: 'og:type', content: 'website', once: true }]
    ],
    link: [
      { rel: 'canonical', href: canonical, once: true },
      ...objHreflangs,
      ...(dnsPrefetch.map(link => ({
        rel: 'preconnect', href: link, once: true
      }))),
      { rel: 'icon', href: `https://www.${site}/favicon.ico`, once: true }
    ],
    script: scripts,
    noscript: noScripts,
    __dangerouslyDisableSanitizersByTagID: disableSanitizers
  }
}
